import { Savings } from '../../_types';

import { OptimizingForPerformanceState } from './_components/OptimizingForPerformanceState';
import { SavingsSummaryProgress } from './SavingsSummaryProgress';
import { Stack } from '@cast/design-system';

type Props = {
  savings: Savings;
  isLoading?: boolean;
};

export const SavingsSummary = ({ savings, isLoading }: Props) => {
  const { estimatedMonthlySavings, estimatedMonthlySavingsPercentage } =
    savings;

  // Show empty state for negative savings (performance optimization scenario)
  if (
    (estimatedMonthlySavings ?? 0) < 0 ||
    (estimatedMonthlySavingsPercentage ?? 0) < 0
  ) {
    return (
      <Stack gap={8} data-testid="savings-summary">
        <OptimizingForPerformanceState />
      </Stack>
    );
  }

  return <SavingsSummaryProgress savings={savings} isLoading={isLoading} />;
};
